<template>
  <span
      v-if="$options.MATCH_STATUS_LABELS[status]"
      class="STATUS-BUBBLE"
      :class="{ 'CANCELED' : status===$options.MATCH_STATUSES.CANCELED }">
    {{ statusLabel }}
  </span>
</template>

<script>
import {
  NEW_MATCH_STATUSES,
  MATCH_STATUS_LABELS,
  ACTIVE_MATCH_STATUSES,
} from '@/constants/match-statuses';
import capitalizeAll from '@/filters/capitalizeAll';

export default {
  MATCH_STATUSES: NEW_MATCH_STATUSES,
  MATCH_STATUS_LABELS,
  ACTIVE_MATCH_STATUSES,
  name: 'status-bubble',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    statusLabel () {
      return capitalizeAll(this.$options.MATCH_STATUS_LABELS[this.status]);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .STATUS-BUBBLE {
    @include text-small;
    display: flex;
    align-items: center;
    height: 3*$unit;
    padding: $unit/4 $unit;
    color: $color-gray70;
    font-weight: 400;
    background-color: $color-gray20;
    border-radius: 2*$unit;
    border: 1px solid $color-gray70;
    text-transform: uppercase;
    will-change: color, background-color;
    transition: color $transition-half-duration,
      background-color $transition-half-duration;

    &.CANCELED {
      color: #CF1322;
      border: 1px solid #CF1322;
      background-color: #FFF1F0;
    }

  }
</style>
